import { Injectable, ViewChild } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ClienteModel } from '../../app/models/ClienteModel';
import { ConcessionariaModel } from "../../app/models/ConcessionariaModel";
import { AlertController } from "ionic-angular";
import { HttpProvider } from "../../providers/http/http";
import { VeiculoModel } from '../../app/models/VeiculoModel';
import { AlertProvider } from '../../providers/alert/alert';
import { Endereco } from '../../app/models/ClienteModel';
import { PreOrdemModel } from '../../app/models/PreOrdemModel';


@Injectable()

export class ConsumidorProvider {


  @ViewChild('autofocusTelefone') ionInputTelefone: { setFocus: () => void; };

  @ViewChild('autofocusNascimento') ionInputNascimento: { setFocus: () => void; };

  @ViewChild('autofocusCep') ionInputCep: { setFocus: () => void; };

  @ViewChild('autofocusDocumento') autofocusDocumento: { setFocus: () => void; };

  cliente: ClienteModel = new ClienteModel();
  endereco: Endereco = new Endereco();
  tipoDoCliente: any = '';
  concessionaria: ConcessionariaModel = new ConcessionariaModel();
  veiculo: VeiculoModel = new VeiculoModel();
  botaoContinuar: boolean = false;
  valida: boolean = false;
  efetuarCadastro: boolean = false;
  preordem: PreOrdemModel = new PreOrdemModel();

  constructor(
    public storage: Storage,
    public alertCtrl: AlertController,
    private httpSrv: HttpProvider,
    private alertSrv: AlertProvider,
  ) {

    this.tipoDoCliente = 'P';

  }

  formataDocumento(documento) {
    documento = documento.replace('-', '');
    documento = documento.replace('.', '');
    documento = documento.replace('.', '');
    documento = documento.replace('/', '');
    return documento
  }

  validaDocumento(documento: string): boolean {
    if (documento === undefined || documento === null || documento === '') {
      return false;
    } else if (documento.length === 14 || documento.length == 11) {
      const cpf = (cpf) => {
        if (typeof cpf !== 'string') return false
        cpf = cpf.replace(/[^\d]+/g, '')
        if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
        cpf = cpf.split('').map(el => +el)
        const rest = (count) => (cpf.slice(0, count - 12)
          .reduce((soma, el, index) => (soma + el * (count - index)), 0) * 10) % 11 % 10
        return rest(10) === cpf[9] && rest(11) === cpf[10]
      }
      return cpf(documento);

    } else if (documento.length === 18) {

      const cnpj = (CNPJ) => {
        let cnpj = CNPJ.trim();
        cnpj = cnpj.replace(/\./g, '');
        cnpj = cnpj.replace('-', '');
        cnpj = cnpj.replace('/', '');
        cnpj = cnpj.split('');
        let v1 = 0;
        let v2 = 0;
        let aux = false;
        for (let i = 1; cnpj.length > i; i++) {
          if (cnpj[i - 1] != cnpj[i]) {
            aux = true;
          }
        }
        if (aux == false) {
          return false;
        }
        for (let i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v1 += cnpj[i] * p1;
          } else {
            v1 += cnpj[i] * p2;
          }
        }
        v1 = (v1 % 11);
        if (v1 < 2) {
          v1 = 0;
        } else {
          v1 = (11 - v1);
        }
        if (v1 != cnpj[12]) {
          return false;
        }
        for (let j = 0, r1 = 6, r2 = 14; (cnpj.length - 1) > j; j++, r1--, r2--) {
          if (r1 >= 2) {
            v2 += cnpj[j] * r1;
          } else {
            v2 += cnpj[j] * r2;
          }
        }
        v2 = (v2 % 11);
        if (v2 < 2) {
          v2 = 0;
        } else {
          v2 = (11 - v2);
        }
        if (v2 != cnpj[13]) {
          return false;
        } else {
          return true;
        }
      }
      return cnpj(documento);

    } else {
      return false;
    }
  }

  genero(value) {
    this.cliente.genero = value;
  }

  async getClienteIntegracao(concessionaria, cliente) {
    this.cliente = cliente;
    this.concessionaria = concessionaria;
    let url = 'v1/getClienteIntegracao';
    let body = {
      "documento": this.cliente.documento,
      "idLoja": this.concessionaria.codConcessionaria,
      "loja" : this.concessionaria,
      "tipoIntegracao": this.concessionaria.tipoIntegracao !== null ? this.concessionaria.tipoIntegracao : 'conecta',
    };

    try {
      let resultado = await this.httpSrv.postApi(url, body, 0, 1);
      let data = resultado.data;
      if (data.cliente !== null && typeof data.cliente !== 'undefined' && data.clienteEncontrado === true) {
        let { nome, telefone, email, documento, genero, nascimento, cep, uf, cidade, bairro, logradouro, complemento, numero, codigoExtra } = data.cliente;
        this.cliente.nome = nome;
        this.cliente.telefone = telefone;
        this.cliente.email = this.cliente.email || email;
        if(documento.length == 11){
          this.cliente.documento = documento;
        }
        this.cliente.nascimento = nascimento;
        this.cliente.codigoExtra = codigoExtra;

        this.endereco.cep = cep;
        this.endereco.uf = uf
        this.endereco.cidade = cidade;
        this.endereco.bairro = bairro;
        this.endereco.logradouro = logradouro;
        this.endereco.complemento = complemento;
        this.endereco.numero = numero;

        this.cliente.endereco = <Endereco>this.endereco;

        genero = genero == "O" ? null : genero;
        this.genero(genero);
        this.efetuarCadastro = true;
      }
      else if(data.clienteEncontrado == false && data.cliente == null){
        this.alertSrv.alert(data.message, 'Ao preencher os campos o cadastro do cliente será realizado.')
      }
    } catch (error) {
      console.log('Problema ao tentar buscar cliente.', error);
    }
    return this.cliente;

  }

  async cadastraClienteCamp() {
    let obj = {
      cliente: {
        nome: this.cliente.nome,
        documento: this.cliente.documento,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        genero: this.cliente.genero,
        nascimento: this.cliente.nascimento,
      },
      endereco: this.endereco,
    }
    let url = 'v1/cadastraCliente'
    let body = {
      "dados": obj,
      "idLoja": this.concessionaria.codConcessionaria,
    }
    try {
      let resultado = await this.httpSrv.postApi(url, body, 1, 1);
      console.log('resultado do cadastro:', resultado);
    } catch (error) {
      console.log('Problema ao cadastrar cliente', error);
    }
  }

  async cadastraClienteIntegracao() {

    let obj = {
      cliente: {
        nome: this.cliente.nome,
        documento: this.cliente.documento,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        genero: this.cliente.genero,
        nascimento: this.cliente.nascimento,
      },
      endereco: this.endereco,
    }
    let url = 'v1/cadastraClienteIntegracao'
    let body = {
      "cliente": obj,
      "idLoja": this.concessionaria.codConcessionaria,
      "tipoIntegracao": this.concessionaria.tipoIntegracao,
      "loja" : this.concessionaria
    }
    try {
      let resultado = await this.httpSrv.postApi(url, body, 1, 1, 'Cadastrando cliente');
      console.log('resultado do cadastro:', resultado);
      this.cliente.codigoExtra = resultado.data.cliente.chaveAcesso;
      return resultado.data.cliente
    } catch (error) {
      console.log('Problema ao cadastrar cliente', error);
    }

  }

  async cadastraCliente(concessionaria, cliente) {
    
    this.concessionaria = concessionaria;
    this.cliente = cliente;
    this.endereco = cliente.endereco;
    if (this.concessionaria.temIntegracaoClientes) {
      let result = await this.cadastraClienteIntegracao();
      return result
    } else {
      await this.cadastraClienteCamp();
      return this.cliente;
    }
  }


  setFocusOnInput(telefone = null, nascimento = null, cep = null, documento = null) {

    if ((telefone == null || telefone == undefined) && (nascimento == null || nascimento == undefined) && (cep == null || cep == undefined) && (documento == null || documento == undefined)) {
      this.ionInputTelefone.setFocus();
      this.ionInputNascimento.setFocus();
      this.ionInputCep.setFocus();
      this.autofocusDocumento.setFocus();
    } else {
      if (telefone == true) {
        this.ionInputTelefone.setFocus();
      }
      if (nascimento == true) {
        this.ionInputNascimento.setFocus();
      }
      if (cep == true) {
        this.ionInputCep.setFocus();
      }
      if (documento == true) {
        this.autofocusDocumento.setFocus();
      }
    }
  }

  async getClienteCamp() {
    let url = 'v1/getCliente';
    let body = {
      "documento": this.cliente.documento,
      "idLoja": this.concessionaria.codConcessionaria,
    };
    try {
      let resultado = await this.httpSrv.postApi(url, body, 1, 1);
      let data = resultado.data;
      if (data.cliente !== null && typeof data.cliente !== 'undefined' && data.clienteEncontrado === true) {
        let { nome, telefone, email, documento, genero, nascimento, cep, uf, cidade, bairro, logradouro, complemento, numero } = data.cliente;
        this.cliente.nome = nome;
        this.cliente.telefone = telefone;
        this.cliente.email = email;
        this.cliente.documento = documento;
        this.cliente.nascimento = nascimento;

        this.endereco.cep = cep;
        this.endereco.uf = uf
        this.endereco.cidade = cidade;
        this.endereco.bairro = bairro;
        this.endereco.logradouro = logradouro;
        this.endereco.complemento = complemento;
        this.endereco.numero = numero;

        this.cliente.endereco = <Endereco>this.endereco;
        this.veiculo.cliente = this.cliente.nome;
        this.veiculo.telefone = this.cliente.telefone;
        this.veiculo.email = this.cliente.email;
        this.veiculo.cpfcpnpj = this.cliente.documento;

        genero = genero == "O" ? null : genero;
        this.genero(genero);
        this.efetuarCadastro = true;
      }

      return this.cliente;
      
    } catch (error) {
      console.log('Problema ao tentar alterar orçamento.', error);
    }
  }

  camposObrigatoriosDoCliente() {

    let nome = this.veiculo.cliente
    let documento = this.cliente.documento;
    let nascimento = this.cliente.nascimento;
    let resultado: boolean = false;
    if (this.tipoDoCliente == "P") {
      resultado = (nome !== undefined && nome !== "") && (documento !== undefined && documento !== "") && (nascimento !== undefined && nascimento !== "") ? true : false;
    } else {
      resultado = (nome !== undefined && nome !== "") && (documento !== undefined && documento !== "") ? true : false;
    }
    resultado = this.efetuarCadastro === true ? resultado : false;
    console.log(`camposObrigatoriosDoCliente() = nome: ${nome}, documento: ${documento}, nascimento: ${nascimento}, resultado: ${resultado}`);
    return resultado;
  }

  camposObrigatoriosDoVeiculo() {
    let placa = this.veiculo.placa
    let km = this.veiculo.km;
    let resultado = (placa !== undefined && placa !== "") && (km !== undefined && km !== "") ? true : false;

    return resultado;
  }

  validaEmail(email) {
    if (email !== null && email !== '') {
      var er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);
      console.log('email preenchido retorna:', er.test(email));
      return er.test(email)
    }
    console.log('email em branco retorna: true')
    return true;
  }

  finalizarFormulario() {
    if (this.efetuarCadastro == true) {
      if (this.camposObrigatoriosDoCliente() === true) {
        let tipoDocumento = this.tipoDoCliente == 'P' ? 11 : 14;
        if (tipoDocumento === this.formataDocumento(this.cliente.documento).length) {
          if (this.validaDocumento(this.cliente.documento)) {
            if (this.validaEmail(this.cliente.email)) {

              this.cadastraCliente(this.concessionaria, this.cliente).then(() => {
                console.log('Cliente foi cadastrado! cadastraCliente()')
              })


            } else {
              this.alertSrv.alert("OPS...", "Email é inválido!");
            }
          } else {
            this.alertSrv.alert("OPS...", "Documento é inválido!");
          }
        } else {
          this.alertSrv.alert("OPS...", "Documento inválido para o tipo do cliente!");
        }
      } else {
        this.alertSrv.alert("OPS...", "Campos obrigatórios precisam ser preenchidos!");
      }
    } else {
      console.log('Cliente não foi cadastrado! finalizarFormulario()')

    }
  }

  async getCliente(documento) {
    if (typeof this.cliente.documento !== 'undefined' && typeof this.cliente.documento !== undefined && this.cliente.documento !== '' && this.cliente.documento !== null) {
      let tipoDocumento = this.tipoDoCliente == 'P' ? 11 : 14;
      if (tipoDocumento === this.formataDocumento(this.cliente.documento).length) {
        if (this.validaDocumento(this.cliente.documento)) {
          if (this.concessionaria.temIntegracaoClientes && this.tipoDoCliente === "P") {
            await this.getClienteIntegracao(this.concessionaria, this.cliente);
          } else {
            await this.getClienteCamp();
          }
        } else {
          this.alertSrv.alert("OPS...", "Documento é inválido!");
        }
      } else {
        this.alertSrv.alert("OPS...", "Documento inválido para o tipo do cliente!");
      }
    } else {
      this.alertSrv.alert("OPS...", "Documento não informado!");
    }
  }

  limpaCampos() {
    this.cliente.nome = "";
    this.cliente.telefone = "";
    this.cliente.email = "";
    this.cliente.genero = "";
    this.cliente.nascimento = "";

    this.veiculo.cliente = "";
    this.veiculo.telefone = "";

    this.endereco.cep = "";
    this.endereco.uf = ""
    this.endereco.cidade = "";
    this.endereco.bairro = "";
    this.endereco.logradouro = "";
    this.endereco.complemento = "";
    this.endereco.numero = "";

    this.cliente.endereco = <Endereco>this.endereco;
    this.veiculo.cliente = "";
    this.veiculo.telefone = "";
    this.veiculo.email = "";
  }

  async buscaCep(paramCep) {
    if (paramCep !== null || paramCep !== undefined || paramCep !== "") {
      try {
        let url = 'v1/buscaCep';
        var body = {
          "cep": paramCep,
        };
        let resultado = await this.httpSrv.postApi(url, body, 1, 1);
        if (resultado.data.cepEncontrado === true) {
          this.endereco = <Endereco>resultado.data.endereco
          this.cliente.endereco = this.endereco;
        } else {
          this.alertSrv.alert("OPS...", "Cep não encontrado.");
        }
      } catch (e) {
        console.log(`houve um error: ${e}`);
      }
    } else {
      this.alertSrv.alert("OPS...", "O campo não pode ser vazio.");
    }
    
    return this.cliente;
  }

}



// WEBPACK FOOTER //
// ./src/providers/consumidor/consumidor.ts